/**
 * Tâche 1305 (Eric 2026-06-30) — Les derniers identifiants cherchés.
 *
 * Gardés dans le navigateur (`localStorage`) et non en base : c'est un
 * confort de poste de travail, pas une donnée de l'organisation — et rien
 * ne part au serveur.
 *
 * Le TITRE est mémorisé avec l'identifiant : une liste de cinq UUID ne dit
 * rien à personne.
 */

const KEY = "knoria.recentIdSearches.v1";
export const MAX_RECENT_IDS = 5;

export function loadRecentIdSearches() {
  try {
    const raw = window.localStorage.getItem(KEY);
    const list = raw ? JSON.parse(raw) : [];
    if (!Array.isArray(list)) return [];
    return list.filter((e) => e && e.id).slice(0, MAX_RECENT_IDS);
  } catch (_) {
    // Navigation privée ou stockage refusé : la fonction disparaît, rien ne casse.
    return [];
  }
}

function persist(list) {
  try {
    window.localStorage.setItem(KEY, JSON.stringify(list));
  } catch (_) { /* stockage refusé : on garde la liste en mémoire seulement */ }
  return list;
}

/** Ajoute (ou remonte) un identifiant trouvé, et rend la nouvelle liste. */
export function rememberIdSearch({ id, title }) {
  if (!id) return loadRecentIdSearches();
  const entry = { id: String(id), title: String(title || "").slice(0, 120) };
  const rest = loadRecentIdSearches().filter((e) => e.id !== entry.id);
  return persist([entry, ...rest].slice(0, MAX_RECENT_IDS));
}

/** Retire un identifiant de la liste, et rend la nouvelle liste. */
export function forgetIdSearch(id) {
  return persist(loadRecentIdSearches().filter((e) => e.id !== id));
}
